<template>
    <a :href="appLinkSuporte" target="_blank" class="text-white">
        <div class="p-4 d-block bg-danger">
            O dispositivo não está com permissão para monitorar essa função.<br>Clique aqui para ajuda.
        </div>
    </a>
</template>

<script>
export default {
  data() {
    return {
      appLinkSuporte: process.env.VUE_APP_LINK_SUPORTE,
    }
  }
}
</script>
